import React from 'react';
export function Footer() {
  return <footer className="bg-primary-dark text-cream/60 py-12 px-4 text-center text-sm" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <p className="mb-4 font-display text-xl text-cream font-bold" data-id="element-89">
          Comida Natural para Perros
        </p>
        <p className="mb-6" data-id="element-90">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <div className="flex justify-center gap-4 mb-6" data-id="element-91">
          <a href="#" className="hover:text-cream transition" data-id="element-92">
            Términos y Condiciones
          </a>
          <span data-id="element-93">|</span>
          <a href="#" className="hover:text-cream transition" data-id="element-94">
            Políticas de Privacidad
          </a>
        </div>
        <p data-id="element-95">© {new Date().getFullYear()} Todos los derechos reservados.</p>
      </div>
    </footer>;
}